// extracted by mini-css-extract-plugin
module.exports = {"form":"create-user-modal_form__YDEP9"};